


import Vue from "vue";
import axios from "axios"
import Router from "vue-router";

import login from "@/components/login/index";
import auth from "@/components/login/auth";
import home from "@/components/index";

import checkin from "@/components/checkin/person";
import checkinDriver from "@/components/checkin/driver";

import paisongluxian from "@/components/paisong/paisongluxian";
import control from "@/components/kanban/index.vue";
import workDesk from "@/components/workDesk";
import ziyuan from "@/components/system/ziyuan.vue";
import cmd from "@/components/cmd/index";

import NotFound from '@/components/NotFound.vue';

import rule from "./rule";
import base from "./base";
import report from "./report";
import pay from "./pay";
import diaodu from "./diaodu";
import diaodu20 from "./diaodu20";
import tangci from "./tangci";
import dataAnalyse from "./dataAnalyse";
import locate from "./locate";
import gongwuche from "./gongwuche";
Vue.use(Router);

const router = new Router({
  routes: [
    { path: '*', component: NotFound },
    {
      path: "/",
      redirect: "/login"
    },
    {
      name: "Login",
      path: "/login",
      component: login
    },
    {
      path: "/auth",
      component: auth
    },
    {
      path: "/home",
      component: home,
      meta: { auth: true },
      children: [
        ...rule,
        {
          path: "/",
          redirect: "/workDesk"
        },
        {
          path: "/control",
          component: control
        }, 

        
        {
          path: "/cmd",
          component: cmd
        },
        {
          path: "/paisongluxian",
          component: paisongluxian
        },    
        {
          path: "/checkin",
          component: checkin
        },
        {
          path: "/checkinDriver",
          component: checkinDriver
        },
        {
          path: "/ziyuan",
          component: ziyuan
        },
        {
          path: "/workDesk",
          component: workDesk
        },
        ...base,
        ...report,
        ...pay,
        ...diaodu,
        ...tangci,
        ...dataAnalyse,
        ...locate,
        ...gongwuche,
         ...diaodu20,
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    var mydata = sessionStorage.getItem(axios.plat);
    if (mydata == null || mydata == "") {
      // 已经登陆
      next({ path: "/login" });
    } else {
      next(); // 正常跳转到你设置好的页面
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js